var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("input", {
      attrs: { id: _vm.id, type: _vm.type, name: _vm.name },
      domProps: { checked: _vm.checked },
      on: { change: _vm.handleChange },
    }),
    _vm._v(" "),
    _c("label", { attrs: { for: _vm.name } }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }